import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { reset } from 'store/monitorRunResultSlice'
import { useAppDispatch, useAppSelector } from 'shared/hooks'
import { setMainBarSettings, setParentUrl, selectMainBarSettings } from 'store/applicationSlice'
import { MarketSpyResultDetail } from 'features/marketSpyResult/marketSpyResultDetail/ui/MarketSpyResultDetail'
import { useReadMonitorByIdQuery } from 'services/monitor'

export const MarketSpyResultDetailPage = () => {
    const { marketSpyId: marketSpyIdFromParams } = useParams()
    const marketSpyIdParsed = parseInt(marketSpyIdFromParams || '')
    const marketSpyId = isNaN(marketSpyIdParsed) ? undefined : marketSpyIdParsed
    const dispatch = useAppDispatch()
    //const mainBarSettings = useAppSelector(selectMainBarSettings)

    useEffect(() => {
        dispatch(reset())

        return () => {
            dispatch(reset())
        }
    }, [dispatch])



    const [readMonitorByIdQueryParams, setReadMonitorByIdQueryParams] = useState<any>(undefined)
    const [readMonitorByIdOptions, setReadMonitorByIdOptions] = useState<any>({
        skip: true
    })

    const {
        data: readMonitorByIdQueryData,
        isLoading: readMonitorByIdQueryIsLoading
    } = useReadMonitorByIdQuery(readMonitorByIdQueryParams, readMonitorByIdOptions)

    useEffect(() => {
        setReadMonitorByIdQueryParams((prev: any) => {
            return {
                ...prev,
                monitorId: marketSpyId
            }
        })

        setReadMonitorByIdOptions((prev: any) => {
            return {
                ...prev,
                skip: marketSpyId === undefined
            }
        })
    }, [
        marketSpyId
    ])


    //useEffect(() => {
    //    if (readMonitorByIdQueryData === undefined) {
    //        return
    //    }

    //    dispatch(setMainBarSettings({
    //        ...mainBarSettings,
    //        title: `Hello`
    //    }))

    //}, [
    //    readMonitorByIdQueryData
    //])

    useEffect(() => {
        dispatch(setMainBarSettings({
            back: {
                url: '/market'
            },
            title: readMonitorByIdQueryData ? `Market Results: ${readMonitorByIdQueryData.title}` : 'Market Results',
            showProfileButton: false
        }))
        dispatch(setParentUrl(`/market`))

        return () => {
            dispatch(setMainBarSettings(undefined))
            dispatch(setParentUrl(undefined))
        }
    }, [
        readMonitorByIdQueryData
    ])

    return (
        <>
            <MarketSpyResultDetail
                marketSpyId={marketSpyId}
            />
        </>
    )
}